function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#000",
  fillRule: "evenodd"
}, React.createElement("path", {
  fillOpacity: 0.65,
  d: "M4.607 6l3.076-3.667a.093.093 0 0 0-.071-.153h-.935a.19.19 0 0 0-.145.066L3.995 5.271 1.458 2.246a.187.187 0 0 0-.144-.066H.38a.093.093 0 0 0-.072.153L3.384 6 .307 9.667a.093.093 0 0 0 .072.153h.935a.19.19 0 0 0 .144-.066l2.537-3.025 2.537 3.025a.187.187 0 0 0 .145.066h.935c.08 0 .123-.092.071-.153L4.607 6zM9.86.632c.396 0 .72.114.978.342.252.228.384.534.384.906s-.144.708-.42 1.008c-.15.156-.444.39-.888.69-.546.366-.858.696-.936.984h2.25V5H8.372c0-.39.138-.744.426-1.062.168-.192.474-.45.93-.762.336-.24.558-.414.672-.534.216-.234.33-.492.33-.768 0-.264-.078-.462-.234-.606-.156-.144-.378-.216-.654-.216-.294 0-.522.096-.678.3-.168.192-.258.48-.264.858h-.492c0-.48.138-.864.402-1.146.264-.288.618-.432 1.05-.432z"
}));

var SvgCloseCopy = function SvgCloseCopy(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCloseCopy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close-copy.cbb3947c.svg";
export { ForwardRef as ReactComponent };